import shopBg from '../images/shop_screen.jpg';

export default function Solutions() {
  return (
    <div style={styles.wrapper}>
      {/* HERO */}
      <section style={styles.hero}>
        <div style={styles.heroBg} />
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Power Your Shop From One Central Hub</h1>

          <p style={styles.heroSub}>
            Our intuitive platform helps you stay ahead of maintenance,
            streamline workflows, and manage your assets and inventory from a
            centralized data hub. With real-time tracking, preventative
            maintenance scheduling, and detailed inspections, you can optimize
            your shops performance and efficiency.
          </p>

          <div style={styles.heroBtns}>
            <button style={styles.primaryBtn}>Request a Demo</button>
          </div>
        </div>
      </section>

      {/* FEATURE BULLETS */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>
          Simplify Shop Management with PeakLabsPro
        </h2>

        <div style={styles.featureGrid}>
          {[
            'Configurable Dashboards',
            'Schedule Maintenance and Manage Inspections',
            'Comprehensive Work History',
            'Barcode Scanner Compatible',
            'Inventory Monitoring',
            'Automatic Alerts',
            'Role-Based Security',
          ].map((item, i) => (
            <div key={i} style={styles.featureCard}>
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* DRIVE EXCELLENCE */}
      <section style={styles.darkSection}>
        <h2 style={styles.sectionTitleLight}>
          Take Control of Your Shop Operations
        </h2>

        <p style={styles.paragraphLight}>
          When manual workflows and legacy systems slow you down, PeakLabsPro
          helps eliminate inefficiencies and centralize your operations, so your
          team can focus on performance, reliability, and results.
        </p>

        <p style={styles.paragraphLight}>
          <strong>End-to-End Visibility:</strong> Manage preventative
          maintenance, work orders, inspections, inventory, shop activity, and
          more from a single, connected platform.
        </p>

        <p style={styles.paragraphLight}>
          <strong>Actionable Intelligence:</strong> Leverage automation and live
          data insights to make faster decisions and maintain full operational
          control.
        </p>
      </section>

      {/* FEATURES SECTION */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Features</h2>

        <div style={styles.featureList}>
          <Feature
            title="Configurable Dashboards and Reports"
            text="Tailor dashboards and generate customizable reports for real-time insights into vehicle usage, maintenance costs, and fleet performance."
          />
          <Feature
            title="Preventative Maintenance"
            text="Schedule maintenance automatically, create work orders, and receive proactive alerts to reduce downtime and extend vehicle lifespan."
          />
          <Feature
            title="Seamless Data Integration"
            text="Integrate telematics, fuel systems, and accounting tools into one centralized platform."
          />
          <Feature
            title="Role-Based Access and Audit Trails"
            text="Control data access and maintain full audit trails for security and compliance."
          />
          <Feature
            title="Mobile Accessibility"
            text="Manage your fleet anywhere with mobile-friendly access and real-time updates."
          />
          <Feature
            title="Configurable Alerts and Notifications"
            text="Set automated email alerts for maintenance, inspections, certifications, and renewals."
          />
          <Feature
            title="Flexible Reporting Modules"
            text="Access many reports or create custom ad-hoc reports tailored to your business."
          />
        </div>
      </section>

      {/* INSPECTIONS */}
      <section style={styles.darkSection}>
        <h2 style={styles.sectionTitleLight}>
          Effortless Fleet Inspections for Total Control
        </h2>

        <Benefit
          title="Increased Efficiency"
          text="Automate inspections and streamline workflows to reduce operational costs."
        />
        <Benefit
          title="Improved Asset Longevity"
          text="Detect issues early and extend asset life."
        />
        <Benefit
          title="Greater Accountability"
          text="Track inspection histories and recurring patterns."
        />
        <Benefit
          title="Centralized Data Management"
          text="All data integrated into one centralized system."
        />
      </section>

      {/* WHY CHOOSE */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Why Choose PeakLabsPro?</h2>

        <Feature
          title="Customizable and User-Friendly"
          text="Adapt workflows, security roles, and user interfaces without impacting upgrades."
        />
        <Feature
          title="Integration Capabilities"
          text="Seamless data import/export with fuel providers, GPS systems, accounting software, and more."
        />
        <Feature
          title="Powerful Reporting and Analytics"
          text="Many reports plus ad-hoc reporting tools for informed decisions."
        />
      </section>

      {/* FINAL CTA */}
      <section style={styles.cta}>
        <h2 style={styles.ctaTitle}>Ready to Transform Your System?</h2>

        <p style={styles.ctaText}>
          Schedule a personalized demo today and see how our customizable fleet
          management solution can revolutionize your operations.
        </p>

        <button style={styles.primaryBtnLarge}>
          Schedule Personalized Demo
        </button>
      </section>
    </div>
  );
}

/* COMPONENTS */

function Feature({ title, text }) {
  return (
    <div style={styles.featureBlock}>
      <h4 style={styles.featureTitle}>{title}</h4>
      <p style={styles.featureText}>{text}</p>
    </div>
  );
}

function Benefit({ title, text }) {
  return (
    <div style={styles.benefitBlock}>
      <h4 style={styles.featureTitle}>{title}</h4>
      <p style={styles.featureText}>{text}</p>
    </div>
  );
}

/* STYLES */

const styles = {
  wrapper: {
    background: '#0f172a',
    color: '#fff',
    fontFamily: 'system-ui, sans-serif',
  },

  hero: {
    position: 'relative',
    padding: '160px 20px',
    textAlign: 'center',
  },

  heroBg: {
    position: 'absolute',
    inset: 0,
    backgroundImage: `url(${shopBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'blur(12px) brightness(0.4)',
    zIndex: 0,
  },

  heroContent: {
    position: 'relative',
    zIndex: 2,
    maxWidth: 1000,
    margin: '0 auto',
  },

  heroTitle: {
    fontSize: 48,
    marginBottom: 20,
  },

  heroSub: {
    fontSize: 18,
    opacity: 0.85,
    marginBottom: 40,
  },

  heroBtns: {
    display: 'flex',
    justifyContent: 'center',
    gap: 20,
  },

  primaryBtn: {
    padding: '14px 36px',
    borderRadius: 12,
    border: 'none',
    background: '#2563eb',
    color: '#fff',
    cursor: 'pointer',
  },

  secondaryBtn: {
    padding: '14px 36px',
    borderRadius: 12,
    border: '1px solid #fff',
    background: 'transparent',
    color: '#fff',
    cursor: 'pointer',
  },

  section: {
    padding: '100px 20px',
    maxWidth: 1100,
    margin: '0 auto',
  },

  darkSection: {
    padding: '100px 20px',
    background: '#111827',
    textAlign: 'center',
  },

  sectionTitle: {
    fontSize: 32,
    marginBottom: 40,
    textAlign: 'center',
  },

  sectionTitleLight: {
    fontSize: 32,
    marginBottom: 30,
  },

  paragraphLight: {
    maxWidth: 900,
    margin: '0 auto 20px',
    opacity: 0.8,
  },

  featureGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))',
    gap: 20,
  },

  featureCard: {
    background: '#1e293b',
    padding: 20,
    borderRadius: 12,
  },

  featureList: {
    display: 'grid',
    gap: 30,
  },

  featureBlock: {
    marginBottom: 20,
  },

  benefitBlock: {
    marginBottom: 20,
  },

  featureTitle: {
    fontSize: 18,
    marginBottom: 8,
  },

  featureText: {
    opacity: 0.75,
    lineHeight: 1.6,
  },

  cta: {
    padding: '120px 20px',
    textAlign: 'center',
  },

  ctaTitle: {
    fontSize: 36,
    marginBottom: 20,
  },

  ctaText: {
    maxWidth: 800,
    margin: '0 auto 40px',
    opacity: 0.8,
  },

  primaryBtnLarge: {
    padding: '18px 50px',
    borderRadius: 14,
    border: 'none',
    fontSize: 16,
    background: '#2563eb',
    color: '#fff',
    cursor: 'pointer',
  },
};
